<template lang="pug">
  div
    Report(v-for="view in views" v-bind:view="view" v-bind:key="view.id")
</template>

<script>
import Report from '@/components/Report'

export default {
  components: {
    Report,
  },
  props: {
    views: Array,
  },
}
</script>